var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(-1030 -1526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    transform: "translate(1030 1526)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "communication",
    transform: "translate(1035 1531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M186.924,171.875a2.446,2.446,0,0,1-1.705,4.183l-31.856.163A34.274,34.274,0,0,1,124.536,160.5c23.142.11,9.532.078,14,.078,25.713,0,41.484-27.758,29.271-49.7a2.362,2.362,0,0,1,.474.171,34.315,34.315,0,0,1,11.019,53.3Z",
    transform: "translate(-104.25 -92.818)",
    fill: "#ebebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M333.356,176.058l-31.856.163V157.167c16.314-8.078,24.074-28.987,14.447-46.287a2.361,2.361,0,0,1,.474.171,34.315,34.315,0,0,1,11.02,53.3l7.62,7.519A2.447,2.447,0,0,1,333.356,176.058Z",
    transform: "translate(-252.387 -92.818)",
    fill: "#dcdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M34.29,0A34.292,34.292,0,0,0,8.348,56.714L.729,64.234a2.445,2.445,0,0,0,1.7,4.183l30.849.147A34.289,34.289,0,1,0,34.29,0Z",
    transform: "translate(0)",
    fill: "#4bd675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M244.788,34.29A34.325,34.325,0,0,1,210.5,68.578V0A34.327,34.327,0,0,1,244.788,34.29Z",
    transform: "translate(-176.21)",
    fill: "#00bf76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M108.45,140.887h29.32a2.443,2.443,0,0,0,0-4.887H108.45a2.443,2.443,0,0,0,0,4.887Z",
    transform: "translate(-88.739 -113.846)",
    fill: "#80f280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M227.686,138.443a2.444,2.444,0,0,1-2.443,2.443H210.5V136h14.742A2.444,2.444,0,0,1,227.686,138.443Z",
    transform: "translate(-176.211 -113.846)",
    fill: "#4bd675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M137.77,196H108.45a2.443,2.443,0,0,0,0,4.887h29.32a2.443,2.443,0,0,0,0-4.887Z",
    transform: "translate(-88.739 -164.072)",
    fill: "#80f280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M227.686,198.443a2.444,2.444,0,0,1-2.443,2.443H210.5V196h14.742A2.444,2.444,0,0,1,227.686,198.443Z",
    transform: "translate(-176.211 -164.072)",
    fill: "#4bd675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M137.77,256H108.45a2.443,2.443,0,0,0,0,4.887h29.32a2.443,2.443,0,0,0,0-4.887Z",
    transform: "translate(-88.739 -214.299)",
    fill: "#80f280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M227.686,258.443a2.444,2.444,0,0,1-2.443,2.443H210.5V256h14.742A2.444,2.444,0,0,1,227.686,258.443Z",
    transform: "translate(-176.211 -214.299)",
    fill: "#4bd675"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.d0c6604cc98b709048895216f78d3fe5.svg";
export { ForwardRef as ReactComponent };